<template>
  <article>
    <transition name="fade" mode="out-in" appear>
      <router-view></router-view>
    </transition>
  </article>
</template>

<script>
import { BARRING_FACTORING_STATUS } from '@route-types';
import { mapState } from 'vuex';

export default {
  name: 'BarringFactoringEditContainer',

  props: {
    edit: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: true,
    };
  },

  computed: {
    ...mapState('barring', ['isChanged']),
  },

  created() {
    if (!this.edit) {
      /**
       * redirect on status page, if page is refreshed.
       * otherwise it would lose the initial state (new/override/edit)
       * */
      this.$router.push({ name: BARRING_FACTORING_STATUS });
    }
    this.$webtrekk.viewPage('sperrprofileaendern', 'authentication.common');
  },

  beforeRouteLeave(to, from, next) {
    if (this.isChanged) {
      // eslint-disable-next-line
      const answer = window.confirm(this.$t('barring.unsavedChangesNotice'));
      if (answer) {
        this.$store.dispatch('barring/setChanged', false);
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
};
</script>
